module.exports = __webpack_public_path__ + "img/about_us.17117c15.png";